module.exports = __webpack_public_path__ + "img/319.ca6e8ff4.jpg";